import React from 'react'
import './index.less'

export default class extends React.Component {
  state = {
    status: false,
  }

  constructor(props) {
    super(props)
  }

  render() {
    let { status, nobg } = this.props
    return (
      <div className={`loading ${!status && 'hide'} ${nobg && 'nobg'}`}>
        <img src="https://h5-activity.yayya.live/img/loading.gif" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/Loading/index.js